/* KBW Stone PDP — slab-size selector.

   Each slab size is a real Shopify variant of the one product. Choosing a
   size never navigates: it swaps the price, compare-at price, SKU, size line
   and availability shown on this page and points the Add to cart form at the
   chosen variant. The pattern is the vanity countertop selector
   (assets/kbw-vanity-pdp.js); kbw-pdp.js still owns the gallery, the
   quantity stepper and the add-to-cart submit.

   The theme's hidden quick-view shell carries its own `input[name="id"]`
   pre-set to this product's first variant (PROJECT.md §9). Every hidden id
   field naming one of THIS product's variants is kept in step, so nothing on
   the page disagrees with the size that was chosen.

   The address follows the choice (?variant=), so a reload or a shared link
   opens on the same size.

   Custom section script — not part of the Maximize theme. */

(function () {
  'use strict';

  var root = document.querySelector('[data-kbw-stone-pdp]');
  if (!root) return;

  var list = root.querySelector('[data-kbw-pdp-size-list]');
  if (!list) return;

  var chips = [].slice.call(list.querySelectorAll('[data-kbw-pdp-size]'));
  if (!chips.length) return;

  var variantIds = chips
    .map(function (c) { return c.getAttribute('data-variant-id'); })
    .filter(Boolean);

  function syncStrayIdFields(variantId) {
    [].slice.call(document.querySelectorAll('input[name="id"]')).forEach(function (field) {
      if (variantIds.indexOf(field.value) !== -1) field.value = variantId;
    });
  }

  function setText(selector, text) {
    [].slice.call(root.querySelectorAll(selector)).forEach(function (el) { el.textContent = text; });
  }

  // The size printed beside the SKU in the identity row. That row is the
  // shared kbw-pdp-identity snippet, whose size span carries no hook of its
  // own; it is the last span of the line the SKU hook sits in.
  function identitySizeEl() {
    var sku = root.querySelector('.kbw-pdp__ident [data-kbw-pdp-sku]');
    var line = sku ? sku.parentNode : null;
    if (!line) return null;
    var spans = [].slice.call(line.children).filter(function (el) {
      return el.tagName === 'SPAN' && el !== sku && !el.classList.contains('kbw-pdp__sep');
    });
    return spans.length ? spans[spans.length - 1] : null;
  }

  function select(chip) {
    if (chip.disabled || chip.getAttribute('data-available') !== 'true') return;

    chips.forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    setText('[data-kbw-pdp-price]', chip.getAttribute('data-price-text') || '');

    var saveText = chip.getAttribute('data-save-text') || '';
    var aside = root.querySelector('[data-kbw-pdp-aside]');
    if (aside) {
      aside.hidden = saveText === '';
      setText('[data-kbw-pdp-was]', chip.getAttribute('data-compare-at-text') || '');
      setText('[data-kbw-pdp-save]', saveText ? 'Save ' + saveText : '');
    }

    var sku = chip.getAttribute('data-sku') || '';
    ['[data-kbw-pdp-sku]', '[data-kbw-pdp-sku-caption]', '[data-kbw-pdp-sku-fact]', '[data-kbw-pdp-sku-crumb]']
      .forEach(function (sel) { if (sku) setText(sel, sku); });

    var size = chip.getAttribute('data-size') || '';
    setText('[data-kbw-pdp-size-caption]', size);
    var identSize = identitySizeEl();
    if (identSize && size) identSize.textContent = size;

    var variantId = chip.getAttribute('data-variant-id') || '';
    var idEl = root.querySelector('[data-kbw-pdp-id]');
    if (idEl) idEl.value = variantId;
    if (variantId) syncStrayIdFields(variantId);

    var cta = root.querySelector('[data-kbw-pdp-cta]');
    if (cta) {
      cta.disabled = false;
      cta.textContent = 'Add to cart';
    }

    var badge = root.querySelector('[data-kbw-pdp-stockbadge]');
    if (badge) {
      badge.classList.add('is-in');
      badge.classList.remove('is-out');
      badge.textContent = 'In stock';
    }

    if (variantId && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {
        /* an address that cannot be rewritten just stays as it was */
      }
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () { select(chip); });
  });
}());
